import { render, staticRenderFns } from "./BusiformMgr.vue?vue&type=template&id=30157952"
import script from "./BusiformMgr.vue?vue&type=script&lang=js"
export * from "./BusiformMgr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports